export const darkTheme = {
  bg: '#0B1220',
  card: '#111C2E',
  text: '#EAF2FF',
  subtext: '#A5B4CC',
  accent: '#3DD9C5',
  sidebarAccent: '#314763',
  surfaceMuted: '#19263B',
  success: '#39C987',
  danger: '#FF6B7D'
}

export const lightTheme = {
  bg: '#F5F7FB',
  card: '#FFFFFF',
  text: '#14213D',
  subtext: '#5B6B88',
  accent: '#0F766E',
  sidebarAccent: '#8AA4C0',
  surfaceMuted: '#EAF1F8',
  success: '#1E9E68',
  danger: '#C4374B'
}
